import { Product, ProductType } from '@/store/modules/product';
import store from '@/store';
import Element, { SpecyficType } from '../element';
import { stringUtil } from '../stringUtil';
import { Vector2 } from '@babylonjs/core';
import { CorrectProductCommand } from '../command/correctProductCommand';

class CorrectnessManager {

    public get isProductCorrect(): boolean {
        const product: Product = store.getters.product;
        // Tylko meble skrzyniowe i biurka mogą być niepoprawne
        if (product.type !== ProductType.CHEST_FURNITURE &&
            product.type !== ProductType.DESK) {
            return true;
        }
        // Meble skrzyniowe muszą być szersze niż 2, żeby były niepoprawne
        if (product.shape.x <= 2) {
            return true;
        }
        const elements: Element[] = store.getters.scene.elements;
        // Meble szerokie na 3 muszą mieć przynajmniej jedną przegrodę pionową
        if (product.shape.x === 3) {
            return elements.some((x) => x.specyficType === SpecyficType.VERTICAL_WALL);
        }
        // Meble szerokie na 4 muszą mięć conajmniej przegrodę na środku, lub dwie gdziekolwiek
        if (product.shape.x === 4) {
            const body: Element = store.getters.body;
            const fullVerticalWalls = elements.filter((x) =>
                x.specyficType === SpecyficType.VERTICAL_WALL &&
                x.shape.y === body.shape.y,
            );
            if (fullVerticalWalls.length === 1) {
                return fullVerticalWalls[0].position.x === 2.5;
            }
            return fullVerticalWalls.length >= 2;
        }
        return true;
    }

    public correctProduct(scenePreview: any, then: (x: boolean, y: boolean) => void = () => { }) {
        const correctProductCommand = new CorrectProductCommand(
            scenePreview,
            then,
        );
        scenePreview.addCommand(correctProductCommand);
    }
}

export const correctnessManager = new CorrectnessManager();
